<template>
  <v-dialog v-model="dialogVisible" max-width="480px" persistent>
    <v-card flat class="pa-4">
      <v-row
        style="position: absolute; top: 4px; right: 4px; z-index: 100"
        no-gutters
      >
        <v-col>
          <v-btn icon x-large @click="close()" color="primary">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="ma-0" align="center">
        <v-col cols="12" class="pa-2 overflow-y-auto">
          <h3>{{ $t("microsite.textTransactionDetail") }}</h3>
          <v-divider class="mt-2 mb-2"></v-divider>
          <div
            v-for="(item, index) in dataTransactionTable"
            :key="index"
            class="mt-2"
            style="color: #000000"
          >
            <v-col cols="12" class="pa-1" v-if="isTypeFile(item.value)">
              <v-row no-gutters>
                <v-col
                  cols="12"
                  class="pa-0 ma-0 text-subtitle-2"
                  style="color: #64748b"
                >
                  {{ formatQuestionTitle(item.header) }} :
                </v-col>
                <v-col cols="auto" class="px-0 py-0 ma-0">
                  <v-row no-gutters>
                    <div
                      v-for="(image, index) in item.value.content"
                      :key="index"
                    >
                      <v-img
                        v-if="isMIMEImage(image.name)"
                        class="mr-1"
                        :src="image.content"
                        width="150"
                        :aspect-ratio="16 / 9"
                        contain
                        @click="handleOpenMediaPreview(image)"
                      >
                      </v-img>
                      <v-img
                        v-else-if="isMIMEVideo(image.name)"
                        src="https://tru-vue.com/wp-content/uploads/2015/11/video-icon.jpg"
                        width="150"
                        :aspect-ratio="16 / 9"
                        contain
                        @click="handleOpenMediaPreview(image)"
                      >
                      </v-img>
                      <div v-else class="d-flex justify-center align-center">
                        <img
                          src="@/assets/images/svg/document.svg"
                          style="cursor: pointer"
                          @click="handleDownloadFile(image)"
                        />
                        {{ image.name }}
                      </div>
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-1" v-if="isTypeImage(item.value)">
              <v-row no-gutters>
                <v-col
                  cols="12"
                  class="pa-0 ma-0 text-subtitle-2"
                  style="color: #64748b"
                >
                  {{ formatQuestionTitle(item.header) }} :
                </v-col>
                <v-col cols="auto" class="px-0 py-0 ma-0">
                  <v-row no-gutters>
                    <div>
                      <v-img
                        class="mr-1"
                        :src="item.value.content"
                        width="150"
                        :aspect-ratio="16 / 9"
                        contain
                        @click="handleOpenMediaPreview(item.value, 'image')"
                      >
                      </v-img>
                      <div
                        v-if="item.value.value"
                        class="text-center mt-2"
                        style="width: 150px"
                      >
                        {{ item.value.value }}
                      </div>
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" v-if="item.header == 'Status'" class="pa-1">
              <v-row no-gutters>
                <v-col
                  cols="auto"
                  class="pa-0 ma-0 text-subtitle-2"
                  style="color: #64748b"
                >
                  {{ formatQuestionTitle(item.header) }} :
                </v-col>
                <v-col cols="auto" class="px-4 py-0 ma-0">
                  <v-chip
                    :color="getStatusColor(item.value)"
                    dark
                    small
                    class="mx-auto"
                  >
                    {{ getStatusText(item.value) }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              class="pa-1"
              v-if="
                item.header == 'Status Detail' &&
                dataTransaction.status == 'Rejected'
              "
            >
              <v-row no-gutters>
                <v-col
                  cols="12"
                  class="pa-0 ma-0 text-subtitle-2"
                  style="color: #64748b"
                >
                  {{ formatQuestionTitle(item.header) }} :
                </v-col>
                <v-col cols="auto" class="px-0 py-0 ma-0">
                  <p
                    class="ma-0"
                    v-html="formatDataTable(item.value, item.header)"
                  ></p>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              v-if="
                typeof item.value != 'object' &&
                item.header != 'Status' &&
                item.header != 'id' &&
                item.header != 'logo' &&
                item.header != 'Status Detail'
              "
              class="pa-1"
            >
              <v-row no-gutters>
                <v-col
                  :cols="item.header == 'Point' ? 'auto' : 12"
                  class="pa-0 ma-0 text-subtitle-2"
                  style="color: #64748b"
                >
                  {{ formatQuestionTitle(item.header) }} :
                </v-col>
                <v-col
                  cols="auto"
                  class="py-0 ma-0"
                  :class="`${item.header == 'Point' ? 'px-4' : 'px-0'}`"
                >
                  <p
                    class="ma-0"
                    v-html="formatDataTable(item.value, item.header)"
                  ></p>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { visibilityDialogDetailQuestion } from "../../../../config/general-function";

export default {
  name: "DialogDetail",
  emits: ["close", "openMediaPreview"],
  props: {
    selectedTransaction: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    templateName: {
      type: String,
      required: false,
      default: null,
    },
    registerTemplateJson: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    campaign: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data: () => ({
    dialogVisible: true,
    formattedSelectedTransaction: {},
    imageUrl: null,
    orderStatusDetail: null,
    valid: true,
    normalRules: [(v) => !!v || "required"],
    statusDetailList: [
      { text: "อนุมัติ", value: "Approved" },
      { text: "รออนุมัติ", value: "Waiting" },
      { text: "ไม่อนุมัติ", value: "Rejected" },
    ],
    dataTransaction: {},
    dataTransactionTable: [],
    mediaDetail: {
      content: null,
      name: "",
    },
  }),
  computed: {
    selectColor() {
      if (this.orderStatusDetail === "Approved") {
        return "green";
      } else if (this.orderStatusDetail === "Under review") {
        return "gray";
      } else {
        return "red";
      }
    },
  },
  mounted() {
    this.dataTransaction = { ...this.selectedTransaction };
    if (this.dataTransaction) {
      for (let key in this.dataTransaction) {
        if (!this.dataTransaction[key]) {
          this.dataTransaction[key] = undefined;
        }
      }
    }
    this.dataTransactionTable.push({
      header: "createdAt",
      value: this.dataTransaction?.createdAt,
    });
    if (Array.isArray(this.registerTemplateJson?.elements)) {
      for (let item of this.registerTemplateJson?.elements) {
        let detail = {
          header: item.name,
          value: undefined,
        };
        if (item.type === "image") {
          continue;
        }
        if (this.dataTransaction[detail.header]) {
          detail.value = this.dataTransaction[detail.header];
        }
        if (item.name == "amount") {
          detail.value = Number.parseFloat(detail.value).toFixed(2);
        }

        this.dataTransactionTable.push(detail);
      }
    }
    this.dataTransaction.statusDetail = this.selectedTransaction.statusDetail
      ? this.selectedTransaction.statusDetail
      : "";
    this.dataTransaction.point = this.selectedTransaction.point
      ? Number.parseFloat(this.selectedTransaction.point).toFixed(2)
      : Number.parseFloat(this.selectedTransaction.amount).toFixed(2);

    this.dataTransaction.amount = this.selectedTransaction.amount
      ? Number.parseFloat(this.selectedTransaction.amount).toFixed(2)
      : "0.00";

    if (
      this.dataTransaction.status == "Rejected" ||
      this.dataTransaction.status == "Waiting"
    ) {
      this.dataTransaction.point = 0;
    }

    let show_type = this.campaign.history_type;

    if (show_type == "all") {
      let summaryAmountValue = this.selectedTransaction.summary_amount
        ? Number.parseFloat(this.selectedTransaction.summary_amount).toFixed(2)
        : "0.00";
      if (
        this.campaign.template_id == 1 &&
        this.campaign.is_use_sum_amount == false
      ) {
        summaryAmountValue = "-";
      }

      this.dataTransactionTable.push({
        header: "Summary Amount",
        value: summaryAmountValue,
      });

      let pointValue = this.selectedTransaction.point
        ? Number.parseFloat(this.selectedTransaction.point).toFixed(2)
        : "0.00";

      if (
        this.campaign.is_use_sum_amount_by_transaction == false &&
        this.campaign.is_use_sum_amount == true
      ) {
        pointValue = "-";
      }
      this.dataTransactionTable.push({
        header: "Point",
        value: pointValue,
      });
    } else if (show_type == "amount") {
      this.dataTransactionTable.push({
        header: "Summary Amount",
        value: this.selectedTransaction.summary_amount
          ? Number.parseFloat(this.selectedTransaction.summary_amount).toFixed(
              2
            )
          : "0.00",
      });
    } else if (show_type == "point") {
      let pointValue = this.selectedTransaction.point
        ? Number.parseFloat(this.selectedTransaction.point).toFixed(2)
        : "0.00";

      if (
        this.campaign.is_use_sum_amount_by_transaction == false &&
        this.campaign.is_use_sum_amount == true
      ) {
        pointValue = "-";
      }

      this.dataTransactionTable.push({
        header: "Point",
        value: pointValue,
      });
    }

    this.dataTransactionTable.push(
      {
        header: "Status",
        value: this.dataTransaction?.status,
      },
      {
        header: "Status Detail",
        value: this.dataTransaction?.statusDetail,
      }
    );
    this.dataTransactionTable = visibilityDialogDetailQuestion(
      this.dataTransactionTable
    );

    this.formatTransaction();
    this.imageUrl = this.getImageFromSelectedTransaction();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getColor(status) {
      if (status === "Approved") {
        return "green";
      } else if (status === "Rejected") {
        return "red";
      } else {
        return "warning";
      }
    },
    isTypeImage(item) {
      if (item?.type == "image") {
        return true;
      }
      return false;
    },
    isTypeFile(item) {
      if (item?.type == "file") {
        return true;
      }
      return false;
    },
    isMIMEImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isMIMEVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    getStatusColor(status) {
      const colors = {
        Approved: "green",
        Waiting: "grey",
        Rejected: "red",
      };
      return colors[status] || "grey";
    },

    getStatusText(statusDetail) {
      const text = this.statusDetailList.find(
        (item) => item.value === statusDetail
      );
      const key_lang = `microsite.${text?.value}`;
      return text ? this.$t(key_lang) : "";
      // return text ? text.text : "";
    },
    handleOpenMediaPreview(param, type) {
      let name = param.name;
      if (type) {
        name = "image.jpg";
      }
      this.mediaDetail.name = name;
      this.mediaDetail.content = param.content;
      this.$emit("openMediaPreview", this.mediaDetail);
    },
    formatTransaction() {
      const excludeKeys = [
        "createdAt",
        "fullname",
        "phone",
        "status",
        "statusDetail",
        "userId",
        "id",
      ];

      // excludekeys and remove image
      this.formattedSelectedTransaction = Object.fromEntries(
        Object.entries(this.selectedTransaction).filter(([key]) => {
          if (!Array.isArray(this.selectedTransaction[key])) {
            return !excludeKeys.includes(key);
          }
        })
      );
    },
    getImageFromSelectedTransaction() {
      let result = [];
      for (var key in this.selectedTransaction) {
        var item = this.selectedTransaction[key];
        if (Array.isArray(item) && item.length > 0) {
          for (var i = 0; i < item.length; i++) {
            if (item[i].type && item[i].type.startsWith("image")) {
              result.push({ src: item[i].content });
            }
          }
        }
      }
      return result;
    },

    formatDataTable(value, key) {
      let _value = value;
      if (_value) {
        if (isNaN(Number(_value))) {
          if (!_value.includes(" ")) {
            const date = moment(_value);
            if (date.isValid()) {
              _value = date.format("DD MMM YYYY, HH:mm:ss");
            }
          }
        } else if (
          ["Point", "amount", "#bill_amount"].includes(key) &&
          !isNaN(Number(_value))
        ) {
          _value = _value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          // const questions = this.registerTemplateJson?.elements || [];
          // const question_number_mask_numeric = questions.find(
          //   (x) => x.name == key && x.type == "text" && x.maskType == "numeric"
          // );
          // if (question_number_mask_numeric) {
          //   _value = _value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          // }
        }
        return _value;
      } else {
        return "-";
      }
    },
    formatQuestionTitle(value) {
      const questions = this.registerTemplateJson?.elements;
      if (Array.isArray(questions)) {
        const question = questions.find((x) => x.name == value);
        value = question?.title || value;
      }
      const map_header = {
        createdAt: "createdAt",
        "Summary Amount": "summary_amount",
        Point: "point",
        Status: "status",
        "Status Detail": "status_detail",
      };
      const key_value = map_header[value];
      const static_header = [
        "createdAt",
        "summary_amount",
        "point",
        "status",
        "status_detail",
      ];
      if (static_header.includes(key_value)) {
        const key_lang = `microsite.${key_value}`;
        value = this.$t(key_lang);
      }
      return value;
    },

    handleDownloadFile(param) {
      const file = param;
      this.downloadFile(file.content, file.name, file.type);
    },
    downloadFile(content, name, type) {
      if (content.startsWith("http") || content.startsWith("https")) {
        // Case 1: Direct URL download
        const link = document.createElement("a");
        link.href = content;
        link.download = name; // File name for download

        // Append the link to the body (for Firefox compatibility)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Remove the link from the document
        document.body.removeChild(link);
      } else if (content.startsWith("data:")) {
        // Case 2: Base64 or data URI download
        const byteCharacters = atob(content.split(",")[1]); // Decode base64
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: type });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = name;

        // Append the link to the body
        document.body.appendChild(link);

        // Trigger download
        link.click();

        // Clean up
        document.body.removeChild(link);
      } else {
        console.error("Invalid content format");
      }
    },
  },
  filters: {},
};
</script>
